import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import moment from 'moment'
import React from 'react'
import { useGetCompanies } from './companies.api'
import { useCompanyStatusEnum } from './companies.enum'
import { ICompany, ICompanyRes } from './companies.type'

export const useConvertCompany = () => {
  const { toString } = useCompanyStatusEnum()
  const converter = (company: ICompanyRes): ICompany => {
    const _convert = (company: ICompanyRes, stackIndex: number): ICompany => {
      return {
        ...company,
        statusStr: toString(company.status),
        stackIndex,
        sessions: company.sessions?.map(d => _convert(d, stackIndex + 1)) || [],
      }
    }
    return {
      ...company,
      statusStr: toString(company.status),
      stackIndex: 0,
      sessions: company.sessions?.map(d => _convert(d, 1)) || [],
    }
  }
  return converter
}

export const useConvertCompanyBalanceAdjust = () => {
  const { byId } = useGetCompanies()

  const converter = React.useCallback(
    (balanceAdjust: any) => {
      return {
        ...balanceAdjust,
        adjustTime: moment(balanceAdjust.adjustTime),
        orgSessionName: byId[balanceAdjust.orgSessionId]?.name || '',
        adjustTimeStr: momentToString(balanceAdjust.adjustTime, 'YYYY/MM'),
      }
    },
    [byId]
  )
  return converter
}
